import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { HomeOutlined, BusinessOutlined } from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

import "../ecrOps/EcrOpsLayout.css";

const NAV_ITEMS = [
    { label: "Home Dashboard", to: "/dashboard", icon: <HomeOutlined /> },
    { label: "Copilot Usage", to: "/leadership/copilot-usage", icon: <BusinessOutlined /> },
];

// Leadership's entire footprint in this app: this page and nothing else.
// Deliberately a standalone layout/sidebar rather than a Leadership carve-out
// inside EcrOpsLayout's much larger nav — Leadership never enters /ecr-ops at
// all (see RequireLeadershipRole), so there's no other route for a stray nav
// item to accidentally expose here. Reuses EcrOpsLayout's own CSS classes for
// a consistent look without duplicating the stylesheet.
const LeadershipLayout = () => {
    const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();

    return (
        <div className="ecr-ops-shell">
            <aside className={`ecr-ops-sidebar ${collapsed ? "collapsed" : ""}`}>
                <div className="ecr-ops-sidebar__header">
                    {!collapsed && (
                        <button
                            className="ecr-ops-sidebar__brand"
                            onClick={() => navigate("/leadership/copilot-usage")}
                            type="button"
                            aria-label="Go to Copilot Usage"
                        >
                            <span className="ecr-ops-sidebar__brand-badge">ECR</span>
                            <span className="ecr-ops-sidebar__brand-label">Leadership</span>
                        </button>
                    )}
                    <button
                        className="ecr-ops-sidebar__toggle"
                        onClick={() => setCollapsed((c) => !c)}
                        aria-label="Toggle sidebar"
                    >
                        {collapsed ? <MenuIcon fontSize="small" /> : <CloseIcon fontSize="small" />}
                    </button>
                </div>

                <nav className="ecr-ops-sidebar__nav">
                    {NAV_ITEMS.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            className={({ isActive }) => `ecr-ops-sidebar__link${isActive ? " active" : ""}`}
                            title={collapsed ? item.label : undefined}
                        >
                            <span className="ecr-ops-sidebar__link-icon">{item.icon}</span>
                            {!collapsed && <span className="ecr-ops-sidebar__link-label">{item.label}</span>}
                        </NavLink>
                    ))}
                </nav>

                {!collapsed && (
                    <div className="ecr-ops-sidebar__footer">
                        <span>ECR Operations</span>
                    </div>
                )}
            </aside>

            <main className="ecr-ops-main">
                <Outlet />
            </main>
        </div>
    );
};

export default LeadershipLayout;
